import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as SiIcons from 'react-icons/si';
import * as MdIcons from 'react-icons/md';
import * as GiIcons from 'react-icons/gi';

export const getIcon = (iconName, size = 22, className = '') => {
  if (!iconName) {
    return <FaIcons.FaCode size={size} className={className} />;
  }

  if (iconName.startsWith('Fa') && FaIcons[iconName]) {
    const IconComponent = FaIcons[iconName];
    return <IconComponent size={size} className={className} />;
  }
  if (iconName.startsWith('Si') && SiIcons[iconName]) {
    const IconComponent = SiIcons[iconName];
    return <IconComponent size={size} className={className} />;
  }
  if (iconName.startsWith('Md') && MdIcons[iconName]) {
    const IconComponent = MdIcons[iconName];
    return <IconComponent size={size} className={className} />;
  }
  if (iconName.startsWith('Gi') && GiIcons[iconName]) {
    const IconComponent = GiIcons[iconName];
    return <IconComponent size={size} className={className} />;
  }

  // Fallback icon
  const Fallback = FaIcons.FaCode;
  return <Fallback size={size} className={className} />;
};

// Available icons list that can be selected in admin forms
export const availableIcons = [
  'FaUnity',
  'SiDotnet',
  'MdAnimation',
  'FaGithub',
  'GiLightningFrequency',
  'SiFirebase',
  'FaCode'
];
